import { Subscription } from '@/types';
import { useEffect, useState } from 'react';
import {
  getRemainingTimeFromTimeDifference,
  getTimeDifference,
} from '../helper';

interface UseCountdown {
  subscription: Subscription;
  callback: () => void;
  futureTimestamp: number;
  timeoutValue?: number;
}

const useCountdown = ({
  subscription,
  callback,
  futureTimestamp,
  timeoutValue = 0,
}: UseCountdown) => {
  const [remainingTime, setRemainingTime] = useState<string>('');
  const [timeDiff, setTimeDiff] = useState<number | undefined>();

  useEffect(() => {
    if (subscription.order_status === 'expired') {
      return;
    }
    if (
      subscription.status === 'waiting_for_payment' ||
      subscription.status === 'pending_address' ||
      subscription.status === 'payment_order'
    ) {
      if (timeDiff && timeDiff < 0) {
        setRemainingTime('00:00:00');
        return;
      }
      const countdown = setInterval(() => {
        const timeDifference = getTimeDifference(futureTimestamp, Date.now());
        setTimeDiff(timeDifference);
        const timeRemaining = getRemainingTimeFromTimeDifference(
          timeDifference
        );
        setRemainingTime(timeRemaining);
      }, 1000);

      if (timeDiff === 0) {
        clearInterval(countdown);
        setRemainingTime('00:00:00');
        setTimeout(() => {
          callback();
        }, timeoutValue);
      }

      // eslint-disable-next-line consistent-return
      return () => clearInterval(countdown);
    }
  }, [remainingTime]);

  return {
    remainingTime,
  };
};

export default useCountdown;
